import React from "react";
import { UserSettingsProvider } from "./context/CurrentUserContext";
import { ToastProvider  } from 'react-toast-notifications';
import NotificationPanel from "../../shared/Components/Notifications";
import { AuthenticatedRoute, PublicRoute } from "./components/AuthRoute";
import { BrowserRouter, Switch } from "react-router-dom";
import { APP_URL_ROOT } from "./../../shared/constanst/constants";
import { AppShell } from "../../shared/AppShell/AppShell";
import { GlobalNavigation } from "./components/GlobalNavigation";
import {LoginView} from "./routes/Login/view";
import { AuxiliaresView } from "./routes/Configuracion/Auxiliares/View";
import { PeriodosView } from "./routes/Configuracion/Periodos/View";
import { UsuariosView } from "./routes/Configuracion/Usuarios/View";
import { PaisesView } from "./routes/Consultas/Paises/View";
import { SumarigramaView } from "./routes/Consultas/Sumarigrama/View";
import { TiposCambioView } from "./routes/Consultas/TiposCambio/View";
import { ImportarFicheroView } from "./routes/GestionDNs/SubirFichero/View";
import { ConsultarLogView } from "./routes/GestionDNs/ConsultarLog/View";
import { DescargarPlantillaView } from "./routes/GestionDNs/DescargarPlantilla/View";
import { SeleccionInformesView } from "./routes/Informes/SeleccionInformes/View";
import { SeleccionInformesView as InformesPeriodoAbiertoView } from "./routes/GestionDNs/InformesPeriodoAbierto/View";
import { SeleccionInformesView as SeleccionInformesExcelView } from "./routes/Informes/seleccionInformesExcel/View";
import { LogImportacionesView } from "./routes/GestionDNs/LogImportaciones/View";
import { InformacionSubidaView } from "./routes/GestionDNs/InformacionSubida/View";
import { ValidacionDNView } from "./routes/GestionDNs/ValidacionDN/View";
import { SeleccionInformesView as SeleccionInformesPeriodoAbiertoExcelView } from "./routes/GestionDNs/seleccionInformesExcel/View";
import { ValidacionesView } from "./routes/Configuracion/Validaciones/View";

export const Routes = (props) => {
  return (
    <UserSettingsProvider>
      <ToastProvider autoDismiss autoDismissTimeout={3000} placement="top-right" TransitionState="entering" components={{ Toast: NotificationPanel }}>
        <BrowserRouter>
              <Switch>
                <PublicRoute exact path={`${APP_URL_ROOT}Login`} component={LoginView} />
                <AppShell appMenu={<GlobalNavigation />}>
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Configuracion/Auxiliares`} component={AuxiliaresView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Configuracion/Usuarios`} component={UsuariosView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Consultas/Sumarigrama`} component={SumarigramaView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Consultas/Paises`} component={PaisesView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Consultas/TiposCambio`} component={TiposCambioView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Configuracion/Periodos`} component={PeriodosView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}GestionDNs/DescargarPlantilla`} component={DescargarPlantillaView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}GestionDNs/SubirFichero`} component={ImportarFicheroView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}GestionDNs/ConsultarLog`} component={ConsultarLogView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Informes/SeleccionInformes`} component={SeleccionInformesView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}GestionDNs/InformesPeriodoAbierto`} component={InformesPeriodoAbiertoView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Informes/SeleccionInformesExcel`} component={SeleccionInformesExcelView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}GestionDNs/LogImportaciones`} component={LogImportacionesView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}GestionDNs/AccesoInformaciónSubida`} component={InformacionSubidaView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}GestionDNs/ValidacionDN`} component={ValidacionDNView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}GestionDNs/SeleccionInformesExcel`} component={SeleccionInformesPeriodoAbiertoExcelView} />
                  <AuthenticatedRoute exact path={`${APP_URL_ROOT}Configuracion/Validaciones`} component={ValidacionesView} />
                </AppShell>
              </Switch>
        </BrowserRouter>
      </ToastProvider>
    </UserSettingsProvider>
  )
}
export default Routes;